<template>
	<div :class="{air__layout__grayBackground: $settings.isGrayBackground}">
		<a-layout
			:class="{
				air__layout__contentNoMaxWidth: $settings.isContentNoMaxWidth,
				air__layout__appMaxWidth: false,
				air__layout__grayBackground: $settings.isGrayBackground,
				air__layout__squaredBorders: $settings.isSquaredBorders,
				air__layout__cardsShadow: $settings.isCardShadow,
				air__layout__borderless: $settings.isBorderless
			}"
		>
			<air-sidebar />
			<air-menu-left v-if="$settings.menuLayoutType === 'left'" />
			<air-menu-top v-if="$settings.menuLayoutType === 'top'" />
			<a-layout>
				<a-layout-header
					class="air__layout__header"
					:class="{
						air__layout__fixedHeader: $settings.isTopbarFixed,
					}"
				>
					<air-topbar v-if="$settings.menuLayoutType !== 'top-dark'" />
					<air-topbar-dark v-if="$settings.menuLayoutType === 'top-dark'" />
					<air-subbar />
				</a-layout-header>
				<a-layout-content>
					<div
						ref="content"
						class="air__utils__content"
					>
						<transition
							:name="$settings.routerAnimation"
							mode="out-in"
						>
							<keep-alive :include="keepAlive">
								<router-view />
							</keep-alive>
						</transition>
					</div>
				</a-layout-content>
				<a-layout-footer>
					<air-footer />
				</a-layout-footer>
				<env-bar />
			</a-layout>
		</a-layout>
	</div>
</template>

<script>
import AirTopbar from '@/system/layouts/app/topBar';
import AirSubbar from '@/system/layouts/app/subBar';
import AirMenuLeft from '@/system/layouts/app/menuLeft';
import AirMenuTop from '@/system/layouts/app/menuTop';
import AirFooter from '@/system/layouts/app/footer';
import AirSidebar from '@/system/layouts/app/sidebar';
import EnvBar from '@/system/layouts/public/env-bar';

export default {
	name: 'AppLayout',
	components: {
		AirTopbar,
		AirSubbar,
		AirMenuLeft,
		AirMenuTop,
		AirFooter,
		AirSidebar,
		EnvBar
	},
	data() {
		return {
			taskCom: null
		};
	},
	computed: {
		keepAlive() {
			let ka = [];

			if (this.$gestios.project.name) ka = this.$app.keepalive;
			return ka.concat(['Home', 'SystemUsers', 'System500', 'System403']);
		}
	},
	mounted() {
		this.detectViewPort(true);
		window.addEventListener('resize', this.detectViewPortListener);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.detectViewPortListener);
	},
	methods: {
		detectViewPortListener() {
			this.detectViewPort(false);
		},
		setViewPort(isMobileView = false, isTabletView = false) {
			this.$store.commit('CHANGE_SETTING', { setting: 'isMobileView', value: isMobileView });
			this.$store.commit('CHANGE_SETTING', { setting: 'isTabletView', value: isTabletView });
		},
		detectViewPort(firstLoad = false) {
			const isMobile = this.$settings.isMobileView;
			const isTablet = this.$settings.isTabletView;
			const width = window.innerWidth;
			const state = {
				next: {
					mobile: width < 768,
					tablet: width < 992,
					desktop: !(width < 768) && !(width < 992)
				},
				prev: {
					mobile: isMobile,
					tablet: isTablet,
					desktop: !(isMobile) && !(isTablet)
				}
			};
			// desktop
			if (state.next.desktop && ((state.next.desktop !== state.prev.desktop) || firstLoad)) {
				this.setViewPort(false, false);
			}
			// tablet & collapse menu
			if (
				state.next.tablet
				&& !state.next.mobile
				&& ((state.next.tablet !== state.prev.tablet) || firstLoad)
			) {
				this.setViewPort(false, true);
				this.$store.commit('CHANGE_SETTING', { setting: 'isMenuCollapsed', value: true });
			}
			// mobile
			if (state.next.mobile && ((state.next.mobile !== state.prev.mobile) || firstLoad)) {
				this.setViewPort(true, false);
			}
		}
	}
};
</script>
